import AnalyticsWrapper from 'analytics';
import googleAnalytics from '@analytics/google-analytics';

const Analytics = AnalyticsWrapper({
  app: 'Reports',
  version: 100,
  plugins: [
    googleAnalytics({
      trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    }),
  ],
});

export default Analytics;
